<div id="upload-image-mobile" class="h-100">

  <div>
    <kl-add-survey-members (membersAdded)="ok()">

    </kl-add-survey-members>
  </div>

</div>
